import * as _ from 'lodash';
import React from 'react';
import './RiskFactorInfoModalContent.scss';
import { RiskFactorScoreTable } from './RiskFactorScoreTable';
import { EventInfo } from './EventInfo';
import TransparentButton from '../../../../shared/button/transparent-button/TransparentButton';

export const RiskFactorInfoModalContent = ({ selectedEvent, closeModal }) => {
    const riskInfo =
        _.get(selectedEvent, 'transactionRisk.overallRiskResult') || {};

    const aml = riskInfo.amlResult || {};
    const rg = riskInfo.rgResult || {};
    const fraud = riskInfo.fraudResult || {};
    const amlHeaders = _.keys(aml.riskFactorResults);
    const rgHeaders = _.keys(rg.riskFactorResults);
    const fraudHeaders = _.keys(fraud.riskFactorResults);
    const amlOverallRiskLevel = aml && aml.riskFactorResults;
    const rgOverallRiskLevel = rg && rg.riskFactorResults;
    const fraudOverallRiskLevel = fraud && fraud.riskFactorResults;
    const amlDetails = aml && aml.riskFactorDetails;
    const rgDetails = rg && rg.riskFactorDetails;
    const fraudDetails = fraud && fraud.riskFactorDetails;

    const showRiskCategoryTable = risk => !_.isEmpty(risk);

    return (
        <div className={'table risk-factor-info-modal-content'}>
            <EventInfo event={selectedEvent} />
            {riskInfo && (
                <div className={'risk-factors-container'}>
                    {showRiskCategoryTable(aml) && (
                        <div className={'risk-factor'}>
                            <span>AML Risk</span>
                            <RiskFactorScoreTable
                                factorHeaders={amlHeaders}
                                overallRiskLevel={amlOverallRiskLevel}
                                details={amlDetails}
                            />
                        </div>
                    )}
                    {showRiskCategoryTable(rg) && (
                        <div className={'risk-factor'}>
                            <span>RG Risk</span>
                            <RiskFactorScoreTable
                                factorHeaders={rgHeaders}
                                overallRiskLevel={rgOverallRiskLevel}
                                details={rgDetails}
                            />
                        </div>
                    )}
                    {showRiskCategoryTable(fraud) && (
                        <div className={'risk-factor'}>
                            <span>Fraud Risk</span>
                            <RiskFactorScoreTable
                                factorHeaders={fraudHeaders}
                                overallRiskLevel={fraudOverallRiskLevel}
                                details={fraudDetails}
                            />
                        </div>
                    )}
                </div>
            )}

            <TransparentButton onClick={() => closeModal()}>
                Close
            </TransparentButton>
        </div>
    );
};
